import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { MdOutlineLogout } from 'react-icons/md';
import { useAuthContext } from '../../../hooks';
import { useStoreContext } from '../../../hooks/useStore';
import { AvatarWithDefaultIcon } from '../../AvatarWithDefaultIcon';

export const NavSideBarFooter = () => {
  const { t } = useTranslation();
  const { signOut } = useAuthContext();
  const {
    store: { user },
  } = useStoreContext();

  return (
    <Flex alignItems='center' mt={6} mb={{ base: 5, lg: 0 }}>
      <AvatarWithDefaultIcon src={user?.avatar} />
      <Box ml={4}>
        <Heading color='brand.white' fontSize='lg'>
          {user?.firstName} {user?.lastName}
        </Heading>
        <Button
          variant='unstyled'
          color='gray.500'
          display='flex'
          alignItems='center'
          fontWeight='500'
          fontSize='sm'
          h='initial'
          onClick={signOut}
        >
          <MdOutlineLogout style={{ transform: 'scaleX(-1)', marginRight: '.5em' }} />
          {t('log.out')}
        </Button>
      </Box>
    </Flex>
  );
};
